import { Platform } from '@angular/cdk/platform';
import { Injectable, afterNextRender, inject, signal } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { images, web } from '../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class MetaService {
  title = inject(Title);
  meta = inject(Meta);
  router = inject(Router);
  platform = inject(Platform);

  displayName = signal<string>('');

  defaults = {
    title: 'cloudigo Malta - 1000+ offers of up to 50%', 
    description: 'Discover hundreds of incredible discounts across Malta & Gozo! Save big at top restaurants, food outlets, fashion stores, home decor shops, pet stores, toy shops, gyms, spas, sports and fitness centers, and so much more with our Malta discount codes without a card!',
    image: '/images/meta/cloudigo.png'
  };

  constructor(){
    afterNextRender(() => {
      try {
        this.displayName.set(localStorage?.getItem('username') ?? '');
      } catch (e){}
    })
  }

  setTags(title?: string, description?: string, image?: string, url?: string){

    const currentUrl = web + this.router.url;
    
    const details = { 
      ...this.defaults,
      url: currentUrl,
      ...title ? {
        title
      } : {},
      ...description ? {
        description
      } : {},
      ...image ? {
        image: image.replace(/^(\/)[^\/]/, (m) => images + m).replace(/^\/\//, '/')
      } : {},
      ...url ? {
        url
      } : {}
    };
    
    this.title.setTitle(details.title);

    const items = [
      { key: 'name', value: 'title', content: details.title },
      { key: 'property', value: 'og:title', content: details.title },
      { key: 'property', value: 'twitter:title', content: details.title },
      { key: 'name', value: 'description', content: details.description },
      { key: 'property', value: 'og:description', content: details.description },
      { key: 'property', value: 'twitter:description', content: details.description },
      { key: 'property', value: 'og:url', content: details.url },
      { key: 'property', value: 'twitter:url', content: details.url },
      { key: 'property', value: 'og:image', content: details.image },
      { key: 'property', value: 'twitter:image', content: details.image },
    ];

    for(const { key, value, content } of items){
      try {
        this.meta.updateTag({
          [key]: value,
          content
        }, `${key}="${value}"`);
      } catch (error){
        //There was an error setting meta tags, we should keep going
      }
    }

  }

  get isBrowser(): boolean {
    return this.platform.isBrowser
  }

  get isMobile(): boolean {
    return this.platform.IOS || this.platform.ANDROID
  }

  get isDesktop(): boolean {
    return !this.isMobile;
  }
}
